import type { CampaignMetrics, MetricEntry } from './useCampaigns';

const METRIC_PILL =
	'rounded-lg bg-[#e9e9e9] px-2 py-1 text-xs font-medium text-[#131313]';

// eslint-disable-next-line react-refresh/only-export-components
export const formatMetricValue = (entry: MetricEntry): string => {
	if (entry.format === 'percent') return `${Math.round(entry.value * 100)}%`;
	return String(entry.value);
};

export const MetricPills = ({
	metrics,
	error,
}: {
	metrics: CampaignMetrics | undefined;
	error?: string | null;
}) => {
	const entries = metrics ? Object.entries(metrics) : [];

	// Nothing to show. A dash here means "no results yet", which is also what a failed
	// fetch used to look like — so when the caller reports a failure, say so instead.
	// Numbers we already have still win over the message: stale beats unknown.
	if (entries.length === 0) {
		if (error)
			return (
				<span className="text-(--text-muted)">Couldn&apos;t load results.</span>
			);
		return <span className="text-(--text-muted)">—</span>;
	}

	return (
		<div className="flex flex-wrap gap-1.5">
			{entries.map(([key, entry]) => (
				<span key={key} className={METRIC_PILL}>
					{entry.label}: {formatMetricValue(entry)}
				</span>
			))}
		</div>
	);
};
